// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_EDIT_USERNAME_YOU_WANNA_ADD = "Zadej jm\u00e9no u\u017eivatelky, kterou chce\u0161 p\u0159idat jako moder\u00e1torku";
